import React, { useState, useEffect,useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Paper, TextField } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import AximDropdown from "components/Dropdown/AximDropdown";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import SendIcon from '@mui/icons-material/Send';

function Feedback({ portal }) {
  const { companyId } = useContext(PrivateRoutesContext);

  const [feedbackType, setFeedbackType] = useState("");
  const [fetchedData, setFetchedData] = useState([]);
  const [subjectVal, setSubjectVal] = useState("");
  const [descVal, setDescVal] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [doDisplayMessage, setDoDisplayMessage] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const isFormComplete = useMemo(() => {
    return feedbackType && subjectVal && descVal;
  },[feedbackType, subjectVal, descVal]);

  const handleChange = (event) => {
    setFeedbackType(event.target.value);
  };
  const handleSubjectVal = (event) => {
    setSubjectVal(event.target.value);
  };
  const handleDescVal = (event) => {
    setDescVal(event.target.value);
  };
  // SUBMIT FORM
  const submitFeedback = () => {
    let feedbackData = {
      feedbackTypeCodeID: feedbackType,
      subject: subjectVal,
      content: descVal,
    };
    
    setIsSubmitting(true);

    apiPost(apiUrls.postFeedbackForm(companyId), feedbackData)
      .then((res) => {
        setTitle("Success!");
        setMessage("Thank you for your feedback!");
        setDoDisplayMessage(true);

        setSubjectVal("");
        setDescVal("");
        setFeedbackType(fetchedData[0].feedbackTypeCodeID);
      })
      .catch((e) => {
        setTitle("Failure");
        setMessage("Error submitting feedback.");
        setDoDisplayMessage(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleChangeCompany = () => {
    apiGet(apiUrls.getFeedbackType(portal)).then((response) => {
      setFetchedData(response.data);

      if (response.data.length > 0) {
        setFeedbackType(response.data[0].feedbackTypeCodeID);
      }
    });
  }
  
  useEffect(() => {
    handleChangeCompany()
  }, [companyId]);

  return (
      <Box className={`${TableStyle.tableWrapper} d-flex justify-content-center align-self-center`}>
      <Paper elevation={4}
        sx={{
          borderRadius: 2,
          p: 4,
          minWidth: 300,
          my: 4
        }}
      >
        <Box className="row" sx={{maxWidth: "700px"}}>
          <Box className="col-12">
            <AximDropdown
              id="feedback-select"
              label="Select Feedback Type"
              handleChange={handleChange}
              value={feedbackType}
              pairs={fetchedData.map(item => ({ value: item.feedbackTypeCodeID, text: item.feedbackTypeName }))} />
          </Box>
          <Box className="col-12 mb-3" sx={{textAlign: "center"}}>
            <TextField
              sx={{"width": "100%"}}
              id="standard-basic"
              label="Subject"
              variant="standard"
              className={ButtonStyle.feedbackSubject}
              value={subjectVal}
              onChange={handleSubjectVal}
            />
          </Box>
          <Box className="col-12 mb-1" sx={{textAlign: "center"}}>
            <TextField
              sx={{"width": "100%"}}
              multiline
              rows={4}
              maxRows={16}
              aria-label="minimum height"
              placeholder="Feedback Notes"
              className={ButtonStyle.feedbackTextarea}
              value={descVal}
              onChange={handleDescVal}
              color="primary"
              size="small"
            />
          </Box>
          <Box className="col-12 d-flex justify-content-end">
            <LoadingButton
              variant="outlined"
              onClick={() => submitFeedback()}
              disabled={isSubmitting || !isFormComplete}
              loading={isSubmitting}
              loadingPosition="start"
              startIcon={<SendIcon />}
            >
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Paper>

      <Dialog
        open={doDisplayMessage}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent sx={{minWidth:'350px'}}>
          {message}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={() => setDoDisplayMessage(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Feedback;
